import { render, staticRenderFns } from "./product-button.vue?vue&type=template&id=37d7ecfc&scoped=true"
import script from "./product-button.vue?vue&type=script&lang=js"
export * from "./product-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7ecfc",
  null
  
)

export default component.exports